import * as Sentry from '@sentry/browser';

export const initializeSentry = () => {
  // if (getEnvironment() === 'PRODUCTION') return;
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration()
      // Session Replay - commented out to disable video recording of sessions
      // Sentry.replayIntegration(),
      // Sentry.replayCanvasIntegration()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'dashboard.school.blueberrymath.ai',
      'dashboard.school.blueberrymath.com'
    ]
    // Session Replay - commented out to disable video recording of sessions
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
